import {ActionsRow, FixedDropDownButton, layout, Loader, ScrollableCard} from 'mc/lib';
import {storeFromArea} from 'mc/lib/utils';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, ButtonToolbar, CardBlock, Col, DropdownItem, Row} from 'reactstrap';
import {
    fetchPlatbaIfNeeded,
    PLATBA_AREA,
    showVratitHotoveModal,
    showVratitPrevodemModal,
    showVyrovnaniModal,
} from '../actions/platbaActions';
import PlatbaUdajeCard from '../components/platba/PlatbaUdajeCard';
import PlatbaVratkyCard from '../components/platba/PlatbaVratkyCard';
import PlatbaVyrovnaniCard from '../components/platba/PlatbaVyrovnaniCard';
import {isHlavickaPlatba, isVraceniEnabled, isVyrovnaniEnabled} from '../utils/platbyUtils';
import * as authActions from "mc/lib/actions/authActions";
import * as appAuthActions from '../actions/appAuthActions';
import * as PopRoleUzivatele from '../api/gen/pop/PopRoleUzivatele';
import {MODULE_CODE_POP} from '../utils/popUtils';

class PlatbaPage extends Component {

    /**
     * Načtení, zda je daný uživatel ma pravo na parovani plateb.
     * @param props
     * @return {boolean}
     */
    isParovaniPlateb = (props = this.props) => {
        const {authInfo} = props;
        if (authInfo.data == null) {
            return false;
        }
        return appAuthActions.hasRole(authInfo.data, MODULE_CODE_POP, PopRoleUzivatele.POP_PAROVANI_PLATEB);
    }

    componentDidMount() {
        this.fetchData(true);
    }

    componentDidUpdate() {
        this.fetchData(false);
    }

    fetchData(force) {
        const {match: {params: {id}}, dispatch} = this.props;
        if (id) {
            dispatch(fetchPlatbaIfNeeded(id, force));
        }
    }

    handleVratitPrevodem = () => {
        const {platba, dispatch} = this.props;
        dispatch(showVratitPrevodemModal(platba.data));
    };

    handleVratitHotove = () => {
        const {platba, dispatch} = this.props;
        dispatch(showVratitHotoveModal(platba.data));
    };

    handleVyrovnat = () => {
        const {platba, dispatch, history} = this.props;
        dispatch(showVyrovnaniModal(platba.data, true, history));
    };

    renderHeaderActions() {
        const platba = this.props.platba.data;
        const isParovaniPlateb = this.isParovaniPlateb();

        return <ButtonToolbar>
            {isParovaniPlateb && isVraceniEnabled(platba) && (
                <FixedDropDownButton title="Vrátit" color="primary-inverse" caret>
                    <DropdownItem onClick={this.handleVratitPrevodem}>Vrátit převodem</DropdownItem>
                    {isHlavickaPlatba(platba) && (
                        <DropdownItem onClick={this.handleVratitHotove}>Vrátit hotově / kartou</DropdownItem>
                    )}
                </FixedDropDownButton>
            )}
            {isParovaniPlateb && isVyrovnaniEnabled(platba) && (
                <Button color="primary-inverse" onClick={this.handleVyrovnat}>Vyrovnat</Button>
            )}
        </ButtonToolbar>;
    }

    renderHeader() {
        return <div>
            <CardBlock>
                <ActionsRow actions={this.renderHeaderActions()}>
                    <h1>Platba</h1>
                </ActionsRow>
            </CardBlock>
        </div>;
    }

    render() {
        const {platba} = this.props;
        const isParovaniPlateb = this.isParovaniPlateb();

        if (platba.isFetching) {
            return <Loader/>;
        }
        if (!platba.fetched) {
            return null;
        }
        return (
            <div className="app-wrapper">
                <div className="app-wrapper-content">
                    <layout.PageWrapper>
                        <layout.PageContent fullWidth header={this.renderHeader()}>
                            <ScrollableCard detail>
                                <Row>
                                    <Col xs={12}>
                                        <PlatbaUdajeCard platba={platba.data}/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={6}>
                                        <PlatbaVyrovnaniCard platba={platba.data} readOnly={!isParovaniPlateb}/>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <PlatbaVratkyCard platba={platba.data}/>
                                    </Col>
                                </Row>
                            </ScrollableCard>
                        </layout.PageContent>
                    </layout.PageWrapper>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    authInfo: storeFromArea(state, authActions.AUTH_INFO_AREA),
    platba: storeFromArea(state, PLATBA_AREA),
});

export default connect(mapStateToProps)(PlatbaPage);
